import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { adminService } from '@/api/services/adminService';

interface Permission {
featureId: string;
assign: boolean;
create: boolean;
edit: boolean;
delete: boolean;
view: boolean;
print: boolean;
approval: boolean;
}

interface PermissionState {
data: Record<string, Permission>;
loading: boolean;
error: string | null;
}

const initialState: PermissionState = {
data: {},
loading: false,
error: null,
};

// Async thunk to fetch permissions by role
export const fetchPermissionsByRole = createAsyncThunk(
'permissions/fetchByRole',
async (roleId: string, { rejectWithValue }) => {
try {
const response = await adminService.featureByIdNew(roleId);
if (response?.success) {
return response.data.permissions;
} else {
return rejectWithValue('Failed to fetch permissions');
}
} catch (err) {
return rejectWithValue(err);
}
}
);

const permissionsSlice = createSlice({
name: 'permissions',
initialState,
reducers: {},
extraReducers: (builder) => {
builder
.addCase(fetchPermissionsByRole.pending, (state) => {
state.loading = true;
state.error = null;
})
.addCase(fetchPermissionsByRole.fulfilled, (state, action) => {
state.loading = false;
state.data = {};
for (const perm of action.payload as Permission[]) {
state.data[perm.featureId] = perm;
}
})
.addCase(fetchPermissionsByRole.rejected, (state, action) => {
state.loading = false;
state.error = action.payload as string;
});
},
});

export default permissionsSlice.reducer;